var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _rect, _path13, _rect2, _path14, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceWaterDrinking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 147,
    viewBox: "0 0 284 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9787 78.0782C67.1151 81.3006 66.5959 84.5172 65.4523 87.5345C64.3088 90.5518 62.5645 93.3074 60.3244 95.6356C58.0843 97.9638 55.3948 99.8164 52.4175 101.082C49.4403 102.348 46.2369 103 43 103C39.7631 103 36.5597 102.348 33.5825 101.082C30.6052 99.8164 27.9157 97.9638 25.6756 95.6356C23.4355 93.3074 21.6913 90.5518 20.5477 87.5345C19.4041 84.5172 18.8849 81.3006 19.0213 78.0782C19.0213 57.1798 42.8082 39 42.8082 39C42.8082 39 66.9787 57.1798 66.9787 78.0782Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_9725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 39,
    width: 48,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9787 78.0782C67.1151 81.3006 66.5959 84.5172 65.4523 87.5345C64.3088 90.5518 62.5645 93.3074 60.3244 95.6356C58.0843 97.9638 55.3948 99.8164 52.4175 101.082C49.4403 102.348 46.2369 103 43 103C39.7631 103 36.5597 102.348 33.5825 101.082C30.6052 99.8164 27.9157 97.9638 25.6756 95.6356C23.4355 93.3074 21.6913 90.5518 20.5477 87.5345C19.4041 84.5172 18.8849 81.3006 19.0213 78.0782C19.0213 57.1798 42.8082 39 42.8082 39C42.8082 39 66.9787 57.1798 66.9787 78.0782Z",
    fill: "#77D3FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_9725)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-13.0271 54.4509L-22.3258 50.6733C-24.2951 49.8733 -26.4006 49.4619 -28.5262 49.4619C-37.6244 49.4619 -45 56.8375 -45 65.9357V93.7696C-45 104.645 -36.1835 113.462 -25.3077 113.462H92.8462C103.722 113.462 112.538 104.645 112.538 93.7696V65.9357C112.538 56.8375 105.163 49.4619 96.0647 49.4619C93.9391 49.4619 91.8336 49.8733 89.8643 50.6733L80.5656 54.4509C75.813 56.3816 70.4947 56.3816 65.7421 54.4509L60.8733 52.4729C56.1207 50.5422 50.8024 50.5422 46.0498 52.4729L41.181 54.4509C36.4284 56.3816 31.1101 56.3816 26.3575 54.4509L21.4887 52.4729C16.7361 50.5422 11.4178 50.5422 6.6652 52.4729L1.79635 54.4509C-2.9562 56.3816 -8.27456 56.3816 -13.0271 54.4509Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-8.10426 70.4509L-17.403 66.6733C-19.3723 65.8733 -21.4778 65.4619 -23.6034 65.4619C-32.7016 65.4619 -40.0771 72.8375 -40.0771 81.9357V109.77C-40.0771 120.645 -31.2606 129.462 -20.3848 129.462H97.769C108.645 129.462 117.461 120.645 117.461 109.77V81.9357C117.461 72.8375 110.086 65.4619 100.988 65.4619C98.8619 65.4619 96.7565 65.8733 94.7872 66.6733L85.4884 70.4509C80.7359 72.3816 75.4175 72.3816 70.665 70.4509L65.7961 68.4729C61.0436 66.5422 55.7252 66.5422 50.9727 68.4729L46.1038 70.4509C41.3513 72.3816 36.0329 72.3816 31.2804 70.4509L26.4115 68.4729C21.659 66.5422 16.3406 66.5422 11.5881 68.4729L6.7192 70.4509C1.96665 72.3816 -3.35171 72.3816 -8.10426 70.4509Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.18141 86.4509L-12.4801 82.6733C-14.4494 81.8733 -16.5549 81.4619 -18.6805 81.4619C-27.7787 81.4619 -35.1543 88.8375 -35.1543 97.9357V125.77C-35.1543 136.645 -26.3377 145.462 -15.462 145.462H102.692C113.568 145.462 122.384 136.645 122.384 125.77V97.9357C122.384 88.8375 115.009 81.4619 105.91 81.4619C103.785 81.4619 101.679 81.8733 99.71 82.6733L90.4113 86.4509C85.6587 88.3816 80.3404 88.3816 75.5878 86.4509L70.719 84.4729C65.9664 82.5422 60.6481 82.5422 55.8955 84.4729L51.0267 86.4509C46.2741 88.3816 40.9558 88.3816 36.2032 86.4509L31.3344 84.4729C26.5818 82.5422 21.2635 82.5422 16.5109 84.4729L11.6421 86.4509C6.8895 88.3816 1.57114 88.3816 -3.18141 86.4509Z",
    fill: "#A1E1FB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4614 82.0771C29.6736 84.0935 31.2014 88.6395 35.6152 90.6925",
    stroke: "white",
    strokeWidth: 5.53846,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0771 71C30.0771 71 29.4618 71.6154 29.4618 72.8462",
    stroke: "white",
    strokeWidth: 5.53846,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.979 78.0782C163.115 81.3006 162.596 84.5172 161.452 87.5345C160.309 90.5518 158.564 93.3074 156.324 95.6356C154.084 97.9638 151.395 99.8164 148.418 101.082C145.44 102.348 142.237 103 139 103C135.763 103 132.56 102.348 129.582 101.082C126.605 99.8164 123.916 97.9638 121.676 95.6356C119.436 93.3074 117.691 90.5518 116.548 87.5345C115.404 84.5172 114.885 81.3006 115.021 78.0782C115.021 57.1798 138.808 39 138.808 39C138.808 39 162.979 57.1798 162.979 78.0782Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11304_9725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 39,
    width: 48,
    height: 64
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.979 78.0782C163.115 81.3006 162.596 84.5172 161.452 87.5345C160.309 90.5518 158.564 93.3074 156.324 95.6356C154.084 97.9638 151.395 99.8164 148.418 101.082C145.44 102.348 142.237 103 139 103C135.763 103 132.56 102.348 129.582 101.082C126.605 99.8164 123.916 97.9638 121.676 95.6356C119.436 93.3074 117.691 90.5518 116.548 87.5345C115.404 84.5172 114.885 81.3006 115.021 78.0782C115.021 57.1798 138.808 39 138.808 39C138.808 39 162.979 57.1798 162.979 78.0782Z",
    fill: "#77D3FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11304_9725)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M82.9729 54.4509L73.6742 50.6733C71.7049 49.8733 69.5994 49.4619 67.4738 49.4619C58.3756 49.4619 51 56.8375 51 65.9357V93.7696C51 104.645 59.8165 113.462 70.6923 113.462H188.846C199.722 113.462 208.538 104.645 208.538 93.7696V65.9357C208.538 56.8375 201.163 49.4619 192.065 49.4619C189.939 49.4619 187.834 49.8733 185.864 50.6733L176.566 54.4509C171.813 56.3816 166.495 56.3816 161.742 54.4509L156.873 52.4729C152.121 50.5422 146.802 50.5422 142.05 52.4729L137.181 54.4509C132.428 56.3816 127.11 56.3816 122.358 54.4509L117.489 52.4729C112.736 50.5422 107.418 50.5422 102.665 52.4729L97.7963 54.4509C93.0438 56.3816 87.7254 56.3816 82.9729 54.4509Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M87.8957 70.4509L78.597 66.6733C76.6277 65.8733 74.5222 65.4619 72.3966 65.4619C63.2984 65.4619 55.9229 72.8375 55.9229 81.9357V109.77C55.9229 120.645 64.7394 129.462 75.6152 129.462H193.769C204.645 129.462 213.461 120.645 213.461 109.77V81.9357C213.461 72.8375 206.086 65.4619 196.988 65.4619C194.862 65.4619 192.756 65.8733 190.787 66.6733L181.488 70.4509C176.736 72.3816 171.418 72.3816 166.665 70.4509L161.796 68.4729C157.044 66.5422 151.725 66.5422 146.973 68.4729L142.104 70.4509C137.351 72.3816 132.033 72.3816 127.28 70.4509L122.412 68.4729C117.659 66.5422 112.341 66.5422 107.588 68.4729L102.719 70.4509C97.9667 72.3816 92.6483 72.3816 87.8957 70.4509Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8186 86.4509L83.5199 82.6733C81.5506 81.8733 79.4451 81.4619 77.3195 81.4619C68.2213 81.4619 60.8457 88.8375 60.8457 97.9357V125.77C60.8457 136.645 69.6623 145.462 80.538 145.462H198.692C209.568 145.462 218.384 136.645 218.384 125.77V97.9357C218.384 88.8375 211.009 81.4619 201.91 81.4619C199.785 81.4619 197.679 81.8733 195.71 82.6733L186.411 86.4509C181.659 88.3816 176.34 88.3816 171.588 86.4509L166.719 84.4729C161.966 82.5422 156.648 82.5422 151.896 84.4729L147.027 86.4509C142.274 88.3816 136.956 88.3816 132.203 86.4509L127.334 84.4729C122.582 82.5422 117.263 82.5422 112.511 84.4729L107.642 86.4509C102.89 88.3816 97.5711 88.3816 92.8186 86.4509Z",
    fill: "#A1E1FB"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.461 82.0771C125.674 84.0935 127.201 88.6395 131.615 90.6925",
    stroke: "white",
    strokeWidth: 5.53846,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.077 71C126.077 71 125.462 71.6154 125.462 72.8462",
    stroke: "white",
    strokeWidth: 5.53846,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.973 79.8477C265.144 83.8758 264.495 87.8966 263.065 91.6682C261.636 95.4398 259.456 98.8843 256.656 101.795C253.855 104.705 250.493 107.021 246.772 108.602C243.05 110.184 239.046 111 235 111C230.954 111 226.95 110.184 223.228 108.602C219.507 107.021 216.145 104.705 213.344 101.795C210.544 98.8843 208.364 95.4398 206.935 91.6682C205.505 87.8966 204.856 83.8758 205.027 79.8477C205.027 53.7248 234.76 31 234.76 31C234.76 31 264.973 53.7248 264.973 79.8477Z",
    fill: "#D9F2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11304_9725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 31,
    width: 60,
    height: 80
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M264.973 79.8477C265.144 83.8758 264.495 87.8966 263.065 91.6682C261.636 95.4398 259.456 98.8843 256.656 101.795C253.855 104.705 250.493 107.021 246.772 108.602C243.05 110.184 239.046 111 235 111C230.954 111 226.95 110.184 223.228 108.602C219.507 107.021 216.145 104.705 213.344 101.795C210.544 98.8843 208.364 95.4398 206.935 91.6682C205.505 87.8966 204.856 83.8758 205.027 79.8477C205.027 53.7248 234.76 31 234.76 31C234.76 31 264.973 53.7248 264.973 79.8477Z",
    fill: "#77D3FA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11304_9725)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M164.966 50.3134L153.343 45.5914C150.881 44.5913 148.249 44.0771 145.592 44.0771C134.219 44.0771 125 53.2966 125 64.6694V99.4618C125 113.056 136.021 124.077 149.615 124.077H297.308C310.902 124.077 321.923 113.056 321.923 99.4618V64.6694C321.923 53.2966 312.704 44.0771 301.331 44.0771C298.674 44.0771 296.042 44.5913 293.58 45.5914L281.957 50.3134C276.016 52.7268 269.368 52.7268 263.428 50.3134L257.342 47.8409C251.401 45.4275 244.753 45.4275 238.812 47.8409L232.726 50.3134C226.786 52.7268 220.138 52.7268 214.197 50.3134L208.111 47.8409C202.17 45.4275 195.522 45.4275 189.581 47.8409L183.495 50.3134C177.555 52.7268 170.907 52.7268 164.966 50.3134Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M171.12 70.3134L159.497 65.5914C157.035 64.5913 154.404 64.0771 151.747 64.0771C140.374 64.0771 131.154 73.2966 131.154 84.6694V119.462C131.154 133.056 142.175 144.077 155.77 144.077H303.462C317.057 144.077 328.077 133.056 328.077 119.462V84.6694C328.077 73.2966 318.858 64.0771 307.485 64.0771C304.828 64.0771 302.196 64.5913 299.735 65.5914L288.111 70.3134C282.171 72.7268 275.523 72.7268 269.582 70.3134L263.496 67.8409C257.555 65.4275 250.907 65.4275 244.967 67.8409L238.881 70.3134C232.94 72.7268 226.292 72.7268 220.351 70.3134L214.265 67.8409C208.324 65.4275 201.676 65.4275 195.736 67.8409L189.65 70.3134C183.709 72.7268 177.061 72.7268 171.12 70.3134Z",
    fill: "#77D3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.274 90.3134L165.65 85.5914C163.189 84.5913 160.557 84.0771 157.9 84.0771C146.527 84.0771 137.308 93.2966 137.308 104.669V139.462C137.308 153.056 148.328 164.077 161.923 164.077H309.615C323.21 164.077 334.231 153.056 334.231 139.462V104.669C334.231 93.2966 325.011 84.0771 313.638 84.0771C310.981 84.0771 308.35 84.5913 305.888 85.5914L294.265 90.3134C288.324 92.7268 281.676 92.7268 275.735 90.3134L269.649 87.8409C263.709 85.4275 257.061 85.4275 251.12 87.8409L245.034 90.3134C239.093 92.7268 232.445 92.7268 226.504 90.3134L220.418 87.8409C214.478 85.4275 207.83 85.4275 201.889 87.8409L195.803 90.3134C189.862 92.7268 183.214 92.7268 177.274 90.3134Z",
    fill: "#A1E1FB"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.077 84.8457C218.342 87.3662 220.252 93.0486 225.77 95.6149",
    stroke: "white",
    strokeWidth: 6.92308,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.846 71C218.846 71 218.076 71.7692 218.076 73.3077",
    stroke: "white",
    strokeWidth: 6.92308,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 101L167.5 105L174.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 101L71.5 105L78.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 26,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 137.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 29.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 50.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195 19L207 33",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 20L259 33.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 128L242.5 145",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceWaterDrinking);
export default __webpack_public_path__ + "static/media/persistence-water-drinking.d245b1a03c958b05263f420edd5e8ada.svg";
export { ForwardRef as ReactComponent };